
function toggleReferrerByEdition(el) {
    var edition_id = el.data('edition-id');

    $.ajax({
        method: 'POST',
        url: `/editions/${edition_id}/toggle`,
        data: [],
        beforeSend: function( xhr ) {
            $(el).addClass('disabled').html('In progress...')
        }
    }).done(function( response ) {
        //window.location.reload(true);

        if ( response.status == 'published' ) {
            $(el).removeClass('disabled').html('<i class="fa fa-check-circle text-success"></i> Published').show()
        } else if ( response.status == 'unpublished' ) {
            $(el).removeClass('disabled').html('<i class="fa fa-times-circle text-danger"></i> Unpublished' ).show()
        }
    });
}

// Should be used when we are enabling publishing per site
function toggleReferrer(el) {
    var edition_id = el.data('edition-id');
    var edition_refferer_id = el.data('refferer-id');

    $.ajax({
        method: 'POST',
        url: `/editions/${edition_id}/refferer/${edition_refferer_id}/toggle`,
        data: [],
        beforeSend: function( xhr ) {
            $(el).addClass('disabled').html('In progress...')
        }
    }).done(function( response ) {
        //window.location.reload(true);

        if ( response.status == 'published' ) {
            $(el).removeClass('disabled').html('<i class="fa fa-check-circle text-success"></i> Published').show()
        } else if ( response.status == 'unpublished' ) {
            $(el).removeClass('disabled').html('<i class="fa fa-times-circle text-danger"></i> Unpublished').show()
        }
    });
}

$('.js-toggle-refferer').on('click', function(){
    if($(this).hasClass('disabled')) {
        return false;
    }
    if( $(this).data('refferer-action') === 'publish' ) {
        if (confirm('Do you want to publish this edition to the websites?')) {
            toggleReferrerByEdition($(this));
            $(this).data('refferer-action', 'unpublish');
        }

    } else if( $(this).data('refferer-action') === 'unpublish' ) {
        if (confirm('Do you want to remove this edition from the websites?')) {
            toggleReferrerByEdition($(this));
            $(this).data('refferer-action', 'publish');
        }
    } else {
        // Unknown action to perform
    }
})
